import { useState, type FormEvent, type ReactNode } from 'react';
import { apiGet, getAppKey, setAppKey } from '../lib/apiClient';
import { PrimaryButton } from './PrimaryButton';

/**
 * Enkel app-grind: API:t kräver ett delat lösenord (?k=) på alla anrop, så utan
 * upplåsning är appen obrukbar och drar inga Google-kostnader. Sparad nyckel
 * släpps igenom optimistiskt — blir den ogiltig 401:ar nästa anrop och
 * apiClient rensar + laddar om till låsskärmen.
 */
export function AppLock({ children }: { children: ReactNode }) {
  const [unlocked, setUnlocked] = useState(() => getAppKey() !== null);
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (unlocked) return <>{children}</>;

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (!value || busy) return;
    setBusy(true);
    setError(null);
    try {
      await apiGet('auth', { k: value });
      setAppKey(value);
      setUnlocked(true);
    } catch {
      setError('Fel lösenord.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="screen screen--photo lock-screen">
      <form className="lock-card" onSubmit={(e) => void submit(e)}>
        <h1 className="lock-title">Bilmat</h1>
        <p className="lock-text">Appen är privat. Ange lösenordet för att fortsätta.</p>
        <input
          className="lock-input"
          type="password"
          autoComplete="current-password"
          placeholder="Lösenord"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(null);
          }}
        />
        {error && <div className="autocomplete-error">{error}</div>}
        <PrimaryButton type="submit" disabled={!value || busy}>
          {busy ? 'Kontrollerar…' : 'Lås upp'}
        </PrimaryButton>
      </form>
    </div>
  );
}
